<script>
  import Loading from "../pages/Loading.svelte";

  export let queries

  let isError = false
  $: if (queries.some(query => query.isError)) {
    isError = true
  }
</script>

{#if isError}
  <h1>Error</h1>
{:else if queries.some(query => query.isLoading)}
  <Loading />
{:else}
  <slot />
{/if}
